import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Home from './pages/Home';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import { Toaster } from './components/ui/sonner';

// reCAPTCHA v3 Site Key
const RECAPTCHA_SITE_KEY = '6LdQ9ocsAAAAAFDJpCv3hL7sTz5Mwpmx376Mwgno';

function App() {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_SITE_KEY}
      language="de"
      scriptProps={{
        async: true,
        defer: true,
      }}
    >
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </GoogleReCaptchaProvider>
  );
}

export default App;